export class NumberSig {
  static round (val) {
    return parseFloat(parseFloat(val).toFixed(4))
  }
}
